import { render, staticRenderFns } from "./totalTask.vue?vue&type=template&id=67e7cc12&"
import script from "./totalTask.vue?vue&type=script&lang=js&"
export * from "./totalTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports